// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-61e88714]:export{primaryColor:#00a0df;secondaryColor:#003479;accentColor:#d91046;brandGreyColor:#4e5054;mainBackgroundColor:#f8f7f7;headerBackgroundColor:#f8f7f7}", ""]);
// Exports
module.exports = exports;
